import { Ilanguages } from 'models/utilitiesModel';

import { IKIOSKModel, IkioskPromotionalData } from '../../../../models/kioskModel';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as _ from 'lodash';
import { getDefaultPromotionalSlideTime } from '../../../../helpers/helpersIndex';

let timer;

const PromotionalSlides: React.FC = () => {
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const promotionalImagesData: IkioskPromotionalData[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.promotionalData || []);
    const orderPromotionalSlides = _.orderBy((promotionalImagesData), 'fileOrder', ['asc', 'desc'])

    const [currentIndex, setCurrentIndex] = useState(0);
    const currentItem: IkioskPromotionalData = orderPromotionalSlides?.[currentIndex];
    const displayTimeSec = currentItem?.displayTimeSec || getDefaultPromotionalSlideTime(); // default is 30 sec 
    useEffect(() => {
        timer = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % orderPromotionalSlides.length);
        }, (1000 * displayTimeSec));
        return () => {
            clearTimeout(timer);
        }

    }, [currentIndex, orderPromotionalSlides]);

    // const handleVideoEnded = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex + 1) % orderPromotionalSlides?.length);
    // };


    return (
        <div className='kiosk_preview_slides'>
            {currentItem.fileType === 'mp4' ? (
                <video width="750" muted
                    autoPlay
                    src={currentItem?.fileUrl}
                    loop
                // onEndedCapture={handleVideoEnded}
                ></video>
            )
                : (
                    <img
                        src={currentItem?.fileUrl}
                        alt={t("kiosktranslation.slideshow" + language)}
                        width="600"
                    />
                )}
        </div>
    )
}
export default React.memo(PromotionalSlides);